import React, { ReactElement, useContext, Suspense, lazy } from 'react';
import { DistributorDataContext, IDistributorDataTypeState } from 'context/DistributorData';

// Lazy load components for code splitting
const Home = lazy(() => import('./Home').then((module) => ({ default: module.Home })));
const HomeAdvantage = lazy(() =>
    import('components/pages/HomeAdvantage').then((module) => ({ default: module.HomeAdvantage }))
);
// Map distributor keys to their custom home components
const DISTRIBUTOR_HOME_COMPONENTS: Record<string, React.LazyExoticComponent<() => ReactElement | null>> = {
    advantage: HomeAdvantage
    // Add more distributors here as needed, e.g.:
    // 'partner-x': HomePartnerX,
};
const HomeRouter = (): ReactElement | null => {
    const distributorContext = useContext(DistributorDataContext) as IDistributorDataTypeState | null;
    const distributorKey = distributorContext?.contextStateDistributorData?.distributorKey ?? '';
    const HomeComponent = DISTRIBUTOR_HOME_COMPONENTS[distributorKey] ?? Home;

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <HomeComponent />
        </Suspense>
    );
};

export { HomeRouter };
